module.exports = __webpack_public_path__ + "static/img/banner.a2694d0f.png";